import request from '@/utils/edu_request'

// seo
export function getRowSeo(params) {
  return request({
    url: '/setting/seo/getRow',
    method: 'get',
    params
  })
}
// 获取推荐课程
export function getCategoryLesson(params) {
  return request({
    url: 'home/index/getCategoryLesson',
    method: 'get',
    params
  })
}
// 获取雷达展示图
export function getRadarImg(params) {
  return request({
    url: 'home/radar/getRadarImg',
    method: 'get',
    params
  })
}